import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { SigninService } from '../../signin/signin.service';
import { MapService } from '../leaflet/service/map.service';
import { AlertManagementService } from '../../pages/alert-management/alert-management.service';
import { DateInterval } from '../../model/date-interval.model';
import { NotificationsComponent } from '../../header/notifications/notifications.component';
import { MapNavigationService } from './map-navigation.service';
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';

@Component({
  selector: 'app-map-top-toolbar',
  templateUrl: './map-top-toolbar.component.html',
  styleUrls: ['./map-top-toolbar.component.scss'],
})
export class MapTopToolbarComponent implements OnInit, OnDestroy {
  notifications: any[] = [];
  private notifTimer: any;
  private dateInterval = new DateInterval();

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    public signinService: SigninService,
    private mapService: MapService,
    private alertManagementService: AlertManagementService,
    private mapNavigationService: MapNavigationService,
    private realTimeWorker: RealtimeWorkerService,
  ) {
  }

  ngOnInit() {
    this.loadNotifications();
    this.notifTimer = setInterval(() => this.loadNotifications(), 20000);

    // Defer push permission until after post-login APIs settle (see signin/header).
    setTimeout(() => {
      void this.alertManagementService.registerPushToken();
    }, 4000);
  }

  ngOnDestroy() {
    if (this.notifTimer) {
      clearInterval(this.notifTimer);
    }
  }

  private loadNotifications() {
    this.alertManagementService
      .getNotifications(this.dateInterval)
      .subscribe({
        next: (notifications) => {
          this.notifications = notifications;
        },
        error: (err) => console.error('Error loading notifications:', err),
      });
  }

  async clickNotifications(ev: any) {
    this.realTimeWorker.prepareMapForOverlay();
    const dialog = await this.modalCtrl.create({
      component: NotificationsComponent,
      showBackdrop: true,
      cssClass: 'notifDialog',
      componentProps: { notifications: this.notifications },
    });
    await dialog.present();
    await dialog.onDidDismiss();
    this.realTimeWorker.restoreMapAfterOverlay();
  }
}
